export const SortDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type SortDirectionType = (typeof SortDirection)[keyof typeof SortDirection];

export const TeamAssociateStatus = {
  Pending: 'Pending',
  SignedUp: 'Signed Up',
  WaitingForApproval: 'Waiting For Approval',
  Verified: 'Verified',
  Blocked: 'Blocked',
  Rejected: 'Rejected',
} as const;

export type TeamAssociateStatusType = keyof typeof TeamAssociateStatus;
